import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../components/ui/Button/Button';
import S from './DetailsGroupStyles';
import useGetUsersByGroupById from '../../../../API/hooks/groups/useGetUsersByGroupById';
import useGetVehiclesByGroupById from '../../../../API/hooks/groups/useGetVehiclesByGroupById';
import { User } from '../../../../API/types/Users';
import { Vehicle } from '../../../../API/types/Vehicles';

type Props = {
  groupId: string;
  fleetId?: string;
  toggleModal: (closed: boolean) => void;
};

function DetailsGroup({ groupId, fleetId, toggleModal }: Props): JSX.Element {
  const { data: users, isLoading: usersIsLoading } = useGetUsersByGroupById(groupId, fleetId || '', '?limit=1000&skip=0', !!fleetId);
  const { data: vehicles, isLoading: vehiclesIsLoading } = useGetVehiclesByGroupById(groupId, fleetId || '', '?limit=1000&skip=0', !!fleetId);
  const navigate = useNavigate();
  const usersList = users?.results || [];
  const vehiclesList = vehicles?.results || [];

  return (
    <S.Wrapper>
      <S.RowContainer>
        Users:
      </S.RowContainer>
      <S.RowContainer>
        {usersIsLoading && (<div className="no-content">loading...</div>)}
        {!usersIsLoading && usersList.length === 0 && (<div className="no-content">No users in group</div>)}
        {!usersIsLoading && usersList.length > 0 && (
          <div className="group-entity">
            {usersList.map((d: User) => (
              <div className="item noclick" key={d._id}>
                <p className="row1">{d.name}</p>
                <p className="row2">{d.email}</p>
              </div>
            ))}
          </div>
        )}
      </S.RowContainer>
      <S.RowContainer>
        Vehicles:
      </S.RowContainer>
      <S.RowContainer>
        {vehiclesIsLoading && (<div className="no-content">loading...</div>)}
        {!vehiclesIsLoading && vehiclesList.length === 0 && (<div className="no-content">No vehicles in group</div>)}
        {!vehiclesIsLoading && vehiclesList.length > 0 && (
          <div className="group-entity">
            {vehiclesList.map((d: Vehicle) => (
              <div className="item" role="presentation" key={d._id} onClick={() => navigate(`/vehicles/${d._id}`)}>
                <p className="row1">{d.licensePlateNumber}</p>
                <p className="row2">{`${d.manufacturer} ${d.model}`}</p>
              </div>
            ))}
          </div>
        )}
      </S.RowContainer>
      <S.RowContainer>
        <p className="disclaimer">* Combined information for current group. For user/vehicle updating, please use the individual setting page.</p>
      </S.RowContainer>
      <S.RowContainer className="buttons-container">
        <Button
          height="50px"
          onClick={() => toggleModal(false)}
          type="button"
        >
          Close
        </Button>
      </S.RowContainer>
    </S.Wrapper>
  );
}

export default DetailsGroup;
